import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import style from "../../../../assets/scss/custom.module.scss";
import SearchField from "../../../common/searchbox/SearchField";

const UserManagmentActionHeader = (props) => {
  const {
    handleDeleteSelected,
    handleKeyDown,
    handleSearchChange,
    disabled,
    tempSearchQuery,
    selectedFlatRows,
    allUsers,
    btnText
  } = props;
  return (
    <div className="d-flex flex-wrap mt-3 mb-3 justify-content-sm-between search">
      <ul
        className={`${style.searchOptionWrap} d-flex flex-wrap align-items-center`}
      >
        <li className="my-1 me-1">
          <Link
            to=""
            className={`btn btn-danger ${selectedFlatRows.length === 0 ? "disabled btn-faded" : ""}`}
            onClick={handleDeleteSelected}
          >
            {btnText}
          </Link>
        </li>
      </ul>
      {allUsers ? (
        <SearchField
          tempSearchQuery={tempSearchQuery}
          handleSearchChange={handleSearchChange}
          handleKeyDown={handleKeyDown}
          loading={disabled}
        />
      ) : null}
    </div>
  );
};

UserManagmentActionHeader.propTypes = {
  handleStatusSort: PropTypes.func,
  statusSort: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleSearchChange: PropTypes.func,
  tempSearchQuery: PropTypes.string,
  handleKeyDown: PropTypes.func,
  handleGroupStatusChange: PropTypes.func,
  disabled: PropTypes.bool,
  handleDeleteSelected: PropTypes.func,
  selectedFlatRows: PropTypes.any,
  allUsers: PropTypes.string,
  btnText: PropTypes.string
};

export default UserManagmentActionHeader;
